import { FormattedMessage } from 'react-intl';
import { Typography } from '@mui/material';
import { InfoContentItem } from 'components/InfoDrawer/InfoContentItem';
import { MeasureInfoContentItem } from 'components/InfoDrawer/MeasureInfoContentItem';
import { Measure } from 'services/model/model.service';

interface PostingDateReportInfoContentProps {
  measures: Measure[];
}

export function PostingDateReportInfoContent({ measures }: PostingDateReportInfoContentProps) {
  return (
    <div>
      <Typography variant="body1" sx={{ fontWeight: 400, mb: 3 }}>
        <FormattedMessage id="info.content.helpful_information" defaultMessage="Helpful information" />
      </Typography>

      <InfoContentItem
        titleId="info.content.why_is_this_view_useful"
        descriptionId="insights.performance.reports.posting_date.info"
      />

      <hr className="my-4 border-snow-200" />
      <Typography variant="body1" sx={{ mb: 3, fontWeight: 400 }}>
        <FormattedMessage id="info.content.kpis" defaultMessage="Key Performance Indicators (KPIs)" />
      </Typography>

      <Typography variant="body2" sx={{ mb: 3, fontWeight: 300 }}>
        <FormattedMessage id="info.content.posting-date.measures" />
      </Typography>

      {measures.map(measure => (
        <MeasureInfoContentItem measure={measure} key={measure.code} isOrderDate={false} />
      ))}

      <hr className="my-4 border-snow-200" />
      <InfoContentItem
        titleId="info.content.data_availability"
        descriptionId="info.content.data_availability.description"
      />
    </div>
  );
}
